module.exports = __webpack_public_path__ + "static/media/dmsans-regular-webfont.2ada6fe5.woff";